import { DEFAULT_THUMBNAIL_CARD_SIZE } from './styles';
import { CONFIG_TYPE } from './types';
import { MIME_TYPES } from 'shared/constants/MIME_TYPES';

const FOUR_GB_IN_BYTES = 4 * 1024 * 1024 * 1024;

export const DEFAULT_CONFIG: CONFIG_TYPE = {
  max_file_size: FOUR_GB_IN_BYTES, // 4GB
  /*
  NOTE: we do video/* and other video formats
  as Safari converts video/* to *.mov
*/
  file_types: [
    'image/*',
    'video/mp4',
    'video/x-m4v',
    'video/*',
    MIME_TYPES.PDF,
  ],
  thumbnailSize: DEFAULT_THUMBNAIL_CARD_SIZE,
  baseUrl: '',
  dataQaPrefix: '',
  atomicChanges: false,
};
